import { makeStyles } from '@material-ui/core';
import { green, neutral, red } from 'shared/styles/colors';

export default makeStyles(() => ({
  container: {
    border: `1px solid ${neutral.D10}`,
    borderRadius: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'PP Object Sans',
    gap: '0.5rem',
    padding: '1rem',
    '& *': {
      fontFamily: 'PP Object Sans',
    },
  },
  title: {
    color: neutral['80'],
    fontFamily: 'PP Object Sans',
    fontSize: '0.625rem',
    fontWeight: 700,
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
  },
  alertDefectProductCheckeded: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: green[10],
    color: neutral[80],
    padding: '0 0.75rem',
    borderRadius: '0.5rem',
    '& svg': {
      fill: green[60],
    },
    '& .MuiAlert-icon': {
      paddingBottom: 0,
      paddingTop: 0,
    },
  },
  alertDefectProductNotCheckeded: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: red[10],
    color: neutral[80],
    padding: '0 0.75rem',
    borderRadius: '0.5rem',
    '& svg': {
      fill: red[60],
    },
    '& .MuiAlert-icon': {
      paddingBottom: 0,
      paddingTop: 0,
    },
  },
  alertMessage: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
  },
}));
